import React from 'react';
import PropTypes from 'prop-types';
import { Button, Header, Text } from '@gasbuddy/react-components';
import { useTranslation, Trans } from 'react-i18next';

export default function PasswordUpdateSuccess({ onDone }) {
  const { t } = useTranslation(['auth', 'miscellaneous']);

  return (
    <React.Fragment>
      <Header as="h3">{t('passwordChange.passwordUpdateSuccess.title', { ns: 'auth' })}</Header>
      <Text as="p">
        <Trans
          i18nKey="passwordChange.passwordUpdateSuccess.message"
          ns="auth"
          components={[
            <a href="https://www.gasbuddy.com" title={t('logoHomePageTitle', { ns: 'miscellaneous' })}>click here to return to GasBuddy.com</a>,
          ]}
        />
      </Text>
      <br />
      <Button
        as="a"
        href="/login"
        cta
        wide
        primary
        onClick={onDone}
      >
        {t('actions.done', { ns: 'miscellaneous' })}
      </Button>
    </React.Fragment>
  );
}

PasswordUpdateSuccess.propTypes = {
  onDone: PropTypes.func.isRequired,
};
